import React from "react";

function Home() {
  return (
    <>
      <div className="container text-center">
        <h2 className=" my-5">Hello there! Welcome to My bookstore!</h2>

        <h5 className="mt-5">
          Kindly navigate using the links at the top right corner.
        </h5>

        <p className="mt-5">
          Create an account or login (if you already have an account) to get
          started.
        </p>
      </div>
    </>
  );
}
export default Home;
